<template>
  <div class="main-content-rows" v-loading="loading">
    <search
      :filted="filted"
      :devs="devs"
      @date-change="dateChange"
      @type-change="typeChange"
      @filted-change="filtedChange"
      @export="exportExcel"
    ></search>

    <div class="main-content-cols">
      <side-menu
        :menus="menus"
        :actived="actived"
        @change="deviceChange"
      ></side-menu>

      <div class="main-content-cols__body">
        <el-row type="flex" style="flex: 1;margin-bottom: 0;">
          <el-col :span="8">
            <vmap ref="" :devs="devs"></vmap>
          </el-col>

          <el-col :span="16">
            <tdata
              ref="table"
              :loading="loadingData"
              :data="tableData"
              @play="goPlay"
            ></tdata>
          </el-col>
        </el-row>

        <el-row type="flex" style="flex: 1">
          <el-col :span="24">
            <schart :devs="devs" :data="tableData"></schart>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import sleep from '@/utlis/sleep'
import SideMenu from '@/components/MainSideMenu'
import Search from './components/search'
import Vmap from './components/map'
import Tdata from './components/tdata'
import imgManager from './components/ImgManager'
import Schart from './components/chart'

import { xph } from '@/service/rodent'

export default {
  props: { _devs: Array },
  components: { SideMenu, Search, Vmap, Tdata, Schart },
  data() {
    return {
      loading: false,
      loadingData: true,
      filted: true,
      menus: [],
      sdata: [],
      videos: [],
      actived: 0,
      query: {
        startTime: '',
        endTime: '',
        deviceId: ''
      }
    }
  },
  computed: {
    tableData() {
      return this.sdata.map(s => {
        let total = 0
        s.labels.forEach(a => (total += a.count))
        let dev = this.devs.find(d => +s.deviceId === d.id)
        return {
          ...s,
          total,
          device: dev.name
        }
      })
    },
    devs() {
      return this._devs.map(r => ({
        title: `${r.address}`,
        ...r
      }))
    },
    dev() {
      return this.devs[this.actived]
    }
  },
  mounted() {
    this.menus = this.devs.map(d => ({ title: d.name, id: d.id }))
  },
  methods: {
    async getData(startTime, endTime) {
      this.loading = true
      const [{ data }] = await Promise.all([
        xph({
          companyId: this.companyId,
          startTime,
          endTime,
          imei: this.dev.imei
        }),
        sleep(1)
      ])

      this.sdata = data.sort((a, b) => {
        return moment(a.dataTime).isAfter(moment(b.dataTime)) ? -1 : 1
      })
      this.loading = false
    },
    deviceChange(idx) {
      this.actived = idx
    },
    dateChange(s, e) {
      this.query.startTime = s
      this.query.endTime = e
      const { startTime, endTime, deviceId } = this.query
      this.getData(startTime, endTime, deviceId)
    },
    typeChange(type) {
      console.log(type)
    },
    filtedChange() {
      this.filted = !this.filted
    },
    exportExcel() {
      const b = moment(this.query.startTime).format('YYYYMMDD')
      const e = moment(this.query.endTime).format('YYYYMMDD')
      this.$refs.table.exportExcel(`鼠害-[${b}-${e}]`)
    },
    goPlay(row) {
      imgManager({ title: row.createdAt, imgUrl: row.orig })
    }
  }
}
</script>

<style lang="css">
.page-rodent .main-content-cols,
.page-rodent .main-content-rows {
  height: 100%;
}
.page-rodent .main-content-sidebar {
  background-color: #fff;
}
</style>
